import type { Metric } from './EntityKey.types.tsx';
import messages from './customFields.messages.tsx';

export const CUSTOM_FIELDS_KEY = 'customField';

export const customFieldsConstants: Metric = {
	key: CUSTOM_FIELDS_KEY,
	visible: true,
	name: messages.name,
	description: messages.description,
	descriptionV2: messages.descriptionV2,
	tabLabels: [messages.chart, messages.reviewAndAnalyze],
	warningMessage: messages.warning,
	exceededMessage: messages.exceeded,
	risks: [messages.risk1],
	mitigations: [],
	currentValueLabel: messages.currentValueLabel,
	currentValueAriaLabel: messages.currentValueAriaLabel,
	thresholdValueLabel: messages.thresholdValueLabel,
	thresholdValueAriaLabel: messages.thresholdValueAriaLabel,
	recommendationUrl:
		'https://support.atlassian.com/jira-cloud-administration/docs/optimize-your-custom-fields/',
	recommendationUrlText: messages.recommendationUrlText,
	recommendationUrlTextV2: messages.recommendationUrlTextV2,
	graphHeader: messages.graphHeader,
	showTooltip: true,
};
